<div>
  <!-- Page Header -->
  <div class="row mb-4">
    <div class="col-md-6">
      <h1 class="h2 mb-1 fw-bold">Reset Integration History</h1>
      <p class="text-muted">View past reset operations and their results</p>
    </div>
    <div class="col-md-6 text-md-end">
      <button type="button" class="btn btn-outline-secondary me-2" (click)="goToDashboard()">
        <i class="bi bi-house me-2"></i>Dashboard
      </button>
      <button type="button" class="btn btn-primary" (click)="goToResetIntegration()">
        <i class="bi bi-arrow-clockwise me-2"></i>New Reset
      </button>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- History Table -->
  <div *ngIf="!loading" class="card overflow-hidden">
    <div class="table-responsive">
      <table class="table data-table table-hover mb-0">
        <thead>
          <tr>
            <th>Executed By</th>
            <th>Date</th>
            <th>Categories</th>
            <th class="text-center">Status</th>
            <th class="text-center">Deleted</th>
            <th class="text-center">Skipped</th>
            <th class="text-center">Errors</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="historyItems.length === 0">
            <td colspan="7" class="text-center text-muted py-4">
              <i class="bi bi-inbox fs-1 d-block mb-2"></i>
              No reset operations found
            </td>
          </tr>
          <tr *ngFor="let item of historyItems">
            <td>
              <div class="d-flex align-items-center">
                <div class="entity-avatar me-2">
                  <i class="bi bi-person"></i>
                </div>
                <span>{{ item.executedBy }}</span>
              </div>
            </td>
            <td>
              <small>{{ formatDate(item.executedAt) }}</small>
            </td>
            <td>
              <small class="text-muted" [title]="item.categories.join(', ')">
                {{ formatCategories(item.categories) }}
              </small>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getStatusClass(item.status)">
                {{ getStatusLabel(item.status) }}
              </span>
            </td>
            <td class="text-center">
              <span class="text-success fw-medium">{{ item.totals.deleted }}</span>
            </td>
            <td class="text-center">
              <span class="text-muted">{{ item.totals.skipped }}</span>
            </td>
            <td class="text-center">
              <span [class.text-danger]="item.totals.errors > 0" [class.text-muted]="item.totals.errors === 0">
                {{ item.totals.errors }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="card-footer" *ngIf="totalPages > 1">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-muted small">
          Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} operations
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="goToPage(currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </a>
            </li>
            <li
              *ngFor="let page of paginationRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" (click)="goToPage(currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
